/** @namespace KevelAnalytics */
import { useState } from 'react'
import {
  recordUrlClick,
  recordImpression,
  recordOrganicImpression,
  recordOrganicClick
} from './helper'

export const ZoneIds = {
  Destination: 264291,
  MidFeed: 258620,
  Organic: 264289,
  Nearby: 257152,
  Featured: 264290,
  FeedOtherZone: 280648,
  ParentCenterLocations: 281190,
  TaxNearby: 281186,
  Similar: 281077,

  // This is not a real Kevel zone ID but is used to push to Segment
  Local: 281220,
  BrandProfile: 285000 // Replace with actual zone ID when created
}

/**
 * Check to see if an element is visible to the user. It only checks to
 *
 * @memberof KevelAnalytics
 * @param {string} [blogImage] If this is present, we skip because
 * we do not care about blog impressions.
 */
const useHook = ({
  impressionUrl,
  clickUrl,
  centerSlug,
  blogImage,
  zoneId
}) => {
  const [hasBeenSeen, sethasBeenSeen] = useState(false)

  const onImpression = (isVisible) => {
    if (!isVisible || blogImage || hasBeenSeen) return
    if (impressionUrl) {
      recordImpression(impressionUrl)
      sethasBeenSeen(true)
      return
    }
    if (centerSlug && ZoneIds.Local === zoneId) {
      handleLocalKevelZone(centerSlug)
      sethasBeenSeen(true)
      return
    }

    if (centerSlug) {
      recordOrganicImpression(centerSlug.replace(/\//g, ''), zoneId)
    }
    sethasBeenSeen(true)
  }

  const handleLocalKevelZone = (centerSlug) => {
    recordOrganicImpression(centerSlug.replace(/\//g, ''), ZoneIds.Organic)
    return
  }

  const handleLocalKevelZoneClick = (centerSlug) => {
    recordOrganicClick(centerSlug.replace(/\//g, ''), ZoneIds.Organic)
    return
  }
  /* */
  const onClick = () => {
    if (clickUrl) {
      recordUrlClick(clickUrl)
      return
    }
    if (centerSlug && ZoneIds.Local === zoneId) {
      handleLocalKevelZoneClick(centerSlug)
      return
    }

    if (centerSlug) {
      recordOrganicClick(centerSlug.replace(/\//g, ''), zoneId)
      return
    }
    return
  }

  return { onImpression, onClick }
}

export default useHook
